import { render, staticRenderFns } from "./jkyFundSelect.vue?vue&type=template&id=0851f9d5&scoped=true"
import script from "./jkyFundSelect.vue?vue&type=script&lang=js"
export * from "./jkyFundSelect.vue?vue&type=script&lang=js"
import style0 from "./jkyFundSelect.vue?vue&type=style&index=0&id=0851f9d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851f9d5",
  null
  
)

export default component.exports